module.exports = "pegasus/assets/blocks/column-lp17-themelp1.png";